exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form__form-group.question label div{font-size:15px;padding:5px;-webkit-box-flex:1;-ms-flex:1 1;flex:1 1}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/scss/component/assessments/question.scss
// module id = 3653
// module chunks = 3